// extracted by mini-css-extract-plugin
export var wrapper = "LoadingWrapper-module--wrapper--ELHh4";
export var wrapperOpen = "LoadingWrapper-module--wrapper-open--a+bxE";
export var button = "LoadingWrapper-module--button--MjakR";